import React from "react";
import { Field } from "redux-form";

import { CustomInput, CustomDropdownByValue } from "components";
import { FormColumn, FormRow } from "components/layout";
import { EnumDto } from "types";
import { trimNormalizer } from "validators";
import {
	maxLength20,
	maxLength9,
	onlyAlphanumericAndSlash,
	onlyAlphanumericAndSpecialCharacters,
} from "validators/validation";

type TsysFieldsProps = {
	loading: boolean;
	name: string;
	fdOmahaProcessorTypes: EnumDto[];
};

export const FdOmahaFields = ({
	loading,
	name,
	fdOmahaProcessorTypes,
}: TsysFieldsProps) => {
	return (
		<>
			<FormRow>
				<FormColumn>
					<Field
						label="Original SYS/PRIN"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						name={`${name}.original_sys_prin`}
						validate={maxLength9}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						normalize={onlyAlphanumericAndSlash}
						hideRequiredMark
					/>
				</FormColumn>
				<FormColumn>
					<Field
						label="Rep Code"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						name={`${name}.rep_code_one`}
						validate={maxLength20}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						normalize={onlyAlphanumericAndSpecialCharacters}
						hideRequiredMark
					/>
				</FormColumn>
			</FormRow>
			<FormRow>
				<FormColumn>
					<Field
						label="Current SYS/PRIN"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						name={`${name}.current_sys_prin`}
						validate={maxLength9}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						normalize={onlyAlphanumericAndSlash}
						hideRequiredMark
					/>
				</FormColumn>
				<FormColumn>
					<Field
						label="Rep Code"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						name={`${name}.rep_code_two`}
						validate={maxLength20}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						normalize={onlyAlphanumericAndSpecialCharacters}
						hideRequiredMark
					/>
				</FormColumn>
			</FormRow>
			<FormRow>
				<FormColumn>
					<Field
						component={CustomDropdownByValue}
						labelName="displayName"
						smLabel={5}
						smSelect={7}
						label="Type"
						name={`${name}.type`}
						items={fdOmahaProcessorTypes}
						loading={loading}
						hideRequiredMark
						emptyValue="0"
					/>
				</FormColumn>
				<Field
					component={CustomInput}
					type="hidden"
					name={`${name}.id`}
					disabled
					wrapperClassName="d-none"
				/>
			</FormRow>
		</>
	);
};
